
import { Product } from '../../types';

// Calculate days of supply for a product
export const calculateDaysOfSupply = (product: Product): number => {
  if (!product.usageRate || product.usageRate <= 0) {
    return 999; // If no usage rate, assume a large number of days
  }
  
  return Math.floor(product.currentStock / product.usageRate);
};

// Check if a product needs restocking
export const needsRestocking = (product: Product): boolean => {
  if (!product.minStockAlert) {
    return false;
  }
  
  const daysOfSupply = calculateDaysOfSupply(product);
  return daysOfSupply <= product.minStockAlert;
};

// Calculate packages to order
export const calculatePackagesToOrder = (product: Product): number => {
  if (!product.packageSize || product.packageSize <= 0 || !product.minStockAlert || !product.usageRate) {
    return 0;
  }
  
  // Calculate target stock level (days of supply * daily usage)
  const targetStock = product.minStockAlert * 2 * product.usageRate;
  
  // Calculate how many units we need to add
  const unitsToAdd = Math.max(0, targetStock - product.currentStock);
  
  // Calculate how many packages that is (round up)
  return Math.ceil(unitsToAdd / product.packageSize);
};
